export default __webpack_public_path__ + "static/media/login-svg.67576717.svg";